export const DEMO_PASSWORD = "nymbl-demo-2026";

export type DemoUserRoleLabel = "RM" | "SO" | "AO" | "Admin";

export type DemoUser = {
  name: string;
  email: string;
  /** DB role (matches the user.role enum: ADMIN/RM/SA/ACCT/FIN). */
  role: "ADMIN" | "RM" | "SA" | "ACCT" | "FIN";
  /** Label shown in the design's role chip. */
  roleLabel: DemoUserRoleLabel;
  initials: string;
  meta: string;
  /** CSS gradient for the avatar bubble. */
  avatarGradient: string;
};

/**
 * Sandbox accounts surfaced on the login screen in every environment except
 * the deployed staging and production hosts (see isDeployedHost in
 * @/lib/environment).
 * Seeded by seedDemoUsers(); rendered by DemoAccountsPanel.
 */
export const DEMO_USERS: readonly DemoUser[] = [
  {
    name: "Maya Okafor",
    email: "maya@demo.nymbl.local",
    role: "RM",
    roleLabel: "RM",
    initials: "MO",
    meta: "Resource Manager · North America · 82 Resources",
    avatarGradient: "linear-gradient(135deg,#2D9BD6,#5461AD)",
  },
  {
    name: "David Chen",
    email: "david@demo.nymbl.local",
    role: "SA",
    roleLabel: "SO",
    initials: "DC",
    meta: "Solution Owner · 11 active Pods",
    avatarGradient: "linear-gradient(135deg,#64479D,#5461AD)",
  },
  {
    name: "Priya Raman",
    email: "priya@demo.nymbl.local",
    role: "ACCT",
    roleLabel: "AO",
    initials: "PR",
    meta: "Account Owner · Acme + Northwind portfolios",
    avatarGradient: "linear-gradient(135deg,#407EC1,#001847)",
  },
];
